import { useState, useMemo, useCallback } from "react";
import utilities, { filterDataUtility, passesFilter } from "./UtilityFunctions"; // or wherever your utility functions live
import fields from "./fields";

export default function useTabularDataManager(dataArray, setData) {
    //console.log("First car",dataArray[0]);
    const [modalVisible, setModalVisibility] = useState({ visible: false, mode: "add" });
    const [messagesModalVisible, setMessagesModalVisible] = useState(false);
    const [sortOrder, setSortOrder] = useState(() => {
        const sortObj = {};
        dataArray && dataArray[0] && Object.keys(dataArray[0]).forEach((propertyName) => {
        sortObj[propertyName] = "none";
        });
        return sortObj;
    }); 

    const [filterObject, setFilterObject] = useState({});

    const sortData = useCallback((field) => {
        setSortOrder(prev => {
        setData(prevData =>
            utilities.sortArray(prevData, field, prev[field] === "asc" ? "desc" : "asc")
        );
        return { ...prev, [field]: prev[field] === "asc" ? "desc" : "asc" };
        });
    }, [setData]);

    const filterData = useCallback((fieldName, filterType, lowerValue, upperValue) => {
        filterDataUtility(setFilterObject, fieldName, filterType, lowerValue, upperValue);
    }, []);

    //Memoized on the two things it actually depends on. Unmemoized, this walked
    //every key of every row on every render of the sheet — a dialog opening
    //re-filtered thousands of rows — and handed back a fresh array identity that
    //invalidated every downstream memo keyed on it.
    const filteredDataArray = useMemo(() => {
        //Only the filtered columns need checking, and there are usually none.
        //The old version iterated all ~40 keys of every row to discover that.
        const activeKeys = Object.keys(filterObject).filter(key => filterObject[key]);
        if (activeKeys.length === 0) return dataArray;

        return dataArray.filter((rowObj) =>
            activeKeys.every(key =>
                //A filter can outlive the column it was set on (sheets differ in
                //shape); an unknown field can't be evaluated, so it can't exclude.
                !(key in rowObj) || !fields[key]
                    ? true
                    : passesFilter(rowObj[key], filterObject[key], fields[key].dataType)
            )
        );
    }, [dataArray, filterObject]);

    return {
        modalVisible, setModalVisibility,
        messagesModalVisible, setMessagesModalVisible,
        sortOrder, sortData,
        filterObject, filterData,
        filteredDataArray
    };
}
